export default (predicate, key) => predicate ? predicate[key] : [];



// WEBPACK FOOTER //
// utils/misc.js